import R from 'ramda'

/**
 * Remove a folder item of `itemId` from a folder of `folderId` from a list of folders
 * @param {Object} item - Information about the item to be removed
 * @param {number} item.folderId - The ID of the folder the item should be removed from
 * @param {number} item.itemId - The ID of the item to be removed
 * @param {Array} folders - The array of folders from the current state
 */
export default function withoutFolderItem({ folderId, itemId }, folders) {
  const folderIndex = R.findIndex(R.propEq('id', folderId), folders)
  if (folderIndex < 0)
    throw new Error(`deleteFolderItem: id ${folderId} not found in array`)

  const { folderItems } = folders[folderIndex]

  const itemIndex = R.findIndex(R.propEq('id', itemId), folderItems)
  if (itemIndex < 0)
    throw new Error(
      `deleteFolderItem: id ${itemId} not found in [${folderId}].folderItems`
    )

  const itemToRemove = R.nth(itemIndex, folderItems)

  return R.adjust(
    folderIndex,
    R.mergeLeft({ folderItems: R.without([itemToRemove], folderItems) }),
    folders
  )
}
